var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoAgenda(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23373",
    "data-name": "Grupo 23373",
    transform: "translate(-106.881 -530)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66290",
    "data-name": "Trazado 66290",
    d: "M124.3,531.834h-.917v-.917a.917.917,0,1,0-1.833,0v.917h-7.333v-.917a.917.917,0,0,0-1.834,0v.917h-.917a4.588,4.588,0,0,0-4.583,4.583v11A4.588,4.588,0,0,0,111.464,552H124.3a4.589,4.589,0,0,0,4.583-4.583v-11A4.589,4.589,0,0,0,124.3,531.834Zm-15.584,4.583a2.75,2.75,0,0,1,2.75-2.75H124.3a2.75,2.75,0,0,1,2.75,2.75v.916H108.714Zm15.584,13.75H111.464a2.75,2.75,0,0,1-2.75-2.75v-8.25h18.334v8.25A2.75,2.75,0,0,1,124.3,550.167Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2158",
    "data-name": "Elipse 2158",
    cx: 1.444,
    cy: 1.444,
    r: 1.444,
    transform: "translate(116.437 542.287)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2159",
    "data-name": "Elipse 2159",
    cx: 1.444,
    cy: 1.444,
    r: 1.444,
    transform: "translate(111.886 542.287)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2160",
    "data-name": "Elipse 2160",
    cx: 1.444,
    cy: 1.444,
    r: 1.444,
    transform: "translate(120.988 542.287)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAgenda);
export default __webpack_public_path__ + "static/media/Icono-Agenda.ff028b28ed47595999e1fdd973500f49.svg";
export { ForwardRef as ReactComponent };